import { TaskType } from "api";
import { atom } from "recoil";

export const taskListAtom = atom<TaskType[]>({
  key: "taskList",
  default: [],
});
